<mat-dialog-content class="adjust-dialog">
  <h2 class="mb-5"
      mat-dialog-title>{{ getDialogTitle() }}</h2>
  <form [formGroup]="form"
        autocomplete="off">
    <!-- Tipo de Mensagem -->
    <mat-form-field class="col-6 mb-2">
      <mat-label>Tipo de Mensagem</mat-label>
      <mat-select formControlName="type">
        <mat-option *ngFor="let option of typeOptions"
                    [value]="option.id"
                    (click)="changedTypeOption(option)">{{ option.label }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('type').invalid">Campo obrigatório</mat-error>
    </mat-form-field>

    <!-- Horário -->
    <mat-form-field class="col-6"
                    *ngIf="showTimeSelector">
      <mat-label>Horário</mat-label>
      <mat-select formControlName="time">
        <mat-option *ngFor="let hour of hours"
                    [value]="hour">{{ hour }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('time').invalid">Campo obrigatório</mat-error>
    </mat-form-field>

    <!-- Dias após fechamento -->
    <mat-form-field class="col-3 mb-2"
                    *ngIf="isPosVenda">
      <mat-label>Os fechada a</mat-label>
      <input matInput
             type="number"
             formControlName="osDay">
      <mat-error *ngIf="form.get('osDay').invalid">Campo obrigatório</mat-error>
    </mat-form-field>

    <!-- Dias após faturamento para Pesquisa de Satisfação -->
    <mat-form-field class="col-6 mb-2"
                    *ngIf="showPesquisaSatisfacao">
      <mat-label>Dias após faturamento</mat-label>
      <input matInput
             type="number"
             formControlName="osFacturedDay"
             placeholder="Quantos dias após o faturamento">
      <mat-error *ngIf="form.get('osFacturedDay')?.invalid">Campo obrigatório</mat-error>
    </mat-form-field>

    <!-- Seleção de Pesquisa para Pesquisa de Satisfação -->
    <mat-form-field class="col-6 mb-2"
                    *ngIf="showPesquisaSatisfacao">
      <mat-label>Pesquisa de Satisfação</mat-label>
      <mat-select formControlName="surveyId">
        <mat-option *ngFor="let survey of availableSurveys"
                    [value]="survey._id">{{ survey.title }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('surveyId')?.invalid">Campo obrigatório</mat-error>
    </mat-form-field>

    <mat-form-field class="col-12 mb-2"
                    *ngIf="showStatisticsMessage">
      <mat-label>Frequência</mat-label>
      <mat-select formControlName="frequency">
        <mat-option *ngFor="let option of frequencyOptions"
                    [value]="option.value"
                    [disabled]="isFrequencyDisabled(option.value)">
          {{ option.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('frequency').invalid">Campo obrigatório</mat-error>
    </mat-form-field>

    <mat-form-field class="col-12 mb-2"
                    *ngIf="showStatisticsMessage">
      <mat-label>Cáculo CMV</mat-label>
      <mat-select formControlName="cmv">
        <mat-option value="averageCost">Utilizar Custo Médio</mat-option>
        <mat-option value="lastCost">Utilizar Último Custo</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Dias antes do vencimento -->
    <mat-form-field class="col-12 mb-2"
                    *ngIf="showDueTitleMessage">
      <mat-label>Dias antes do vencimento</mat-label>
      <input matInput
             type="number"
             formControlName="titleMessageDay">
      <mat-error *ngIf="form.get('titleMessageDay').invalid">Campo obrigatório</mat-error>
    </mat-form-field>

     <!-- Dias depois do vencimento -->
    <mat-form-field class="col-12 mb-2"
                    *ngIf="showChargeMessage">
      <mat-label>Dias depois do vencimento</mat-label>
      <input matInput
             type="number"
             formControlName="titleMessageDay">
      <mat-error *ngIf="form.get('titleMessageDay').invalid">Campo obrigatório</mat-error>
    </mat-form-field>

  <!-- Mensagem -->

  @if (!isLaborWarningMessage && !showCashFlowMessage && !showStatisticsMessage && !showAniversarianteMessage) {
    <mat-form-field class="mat-form-field col-12 d-flex flex-column mb-2">
      <mat-label>Mensagem</mat-label>
      <textarea matInput
                maxlength="300"
                rows="4"
                class="mt-2"
                formControlName="message"
                #observationInput></textarea>
      <button mat-icon-button
              class="emoji-button position-absolute"
              (click)="toggleEmojiPicker(); $event.stopPropagation();">
        😊
      </button>
      <mat-error *ngIf="form.get('message').invalid">Campo obrigatório</mat-error>
    </mat-form-field>
  }

    <!-- Variações de mensagem (apenas para tipo ANIVERSARIANTE) -->
    <div *ngIf="showAniversarianteMessage" class="col-12">
      <h4>
        Variações de Mensagem
        <span class="required-asterisk" *ngIf="messageVariations.hasValidator(Validators.required)">*</span>
      </h4>
      <p class="text-muted">Adicione variações de mensagens que serão enviadas aleatoriamente</p>

      <div formArrayName="messageVariations">
        <div *ngFor="let variation of messageVariations.controls; let i = index" class="mb-4">
          <div class="ml-3 mb-3 variables-buttons-row">
            <small class="text-muted mr-2">Adicionar variável:</small>
            <div class="d-flex flex-wrap">
              <button *ngFor="let variable of availableVariables"
                      mat-stroked-button
                      size="small"
                      class="mr-2 mb-2 variable-button"
                      (click)="insertVariableInVariation(variable.key, i)">
                {{variable.key}}
              </button>
            </div>
          </div>
          <div class="d-flex align-items-center ">
            <mat-form-field class="col-11">
              <mat-label>Variação {{i+1}}</mat-label>
              <textarea matInput
                        [formControlName]="i"
                        maxlength="300"
                        rows="3"
                        #variationInput></textarea>
              <button mat-icon-button
                      class="emoji-button position-absolute"
                      (click)="toggleVariationEmojiPicker(i); $event.stopPropagation();">
                😊
              </button>
              <mat-error *ngIf="variation.touched && !variation.value?.trim()">
                Preencha o texto da mensagem
              </mat-error>
            </mat-form-field>
            <button mat-icon-button color="warn" (click)="removeMessageVariation(i)" class="col-1"
                    [disabled]="messageVariations.controls.length <= 1">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <button mat-stroked-button color="primary" type="button" (click)="addMessageVariation()">
        <mat-icon>add</mat-icon> Adicionar Variação
      </button>

      <!-- Erro do FormArray -->
      <div *ngIf="messageVariations.invalid && messageVariations.touched" class="text-danger mt-2">
        Pelo menos uma variação de mensagem deve ser preenchida
      </div>
    </div>

    <div class="ajust-emoji"
         *ngIf="showVariationEmojiPicker || showEmojiPicker">
      <emoji-mart (emojiClick)="addEmoji($event)"></emoji-mart>
    </div>

    <div *ngIf="showAvailableVariables"
         class="available-variables">
      <h4>Utilize as seguintes palavras-chave:</h4>
      <div class="variables-list">
        <div *ngFor="let variable of availableVariables"
             class="variable-item"
             (click)="insertVariable(variable.key)">
          <strong>{{variable.key}}</strong> - {{variable.description}}
        </div><br>

        <p>Exemplo de mensagem: {{exampleMessage}}</p>
      </div>
    </div>

    <div *ngIf="showCashFlowMessage || showDueTitleMessage || showStatisticsMessage"
         class="col-12 mb-2">
      <mat-form-field class="w-100">
        <mat-label>Buscar destinatários</mat-label>
        <input matInput
               [formControlName]="'recipientSearch'"
               [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete"
                          (optionSelected)="selectUser($event.option.value)">
          @for (user of filteredUsers(); track user._id) {
          <mat-option [value]="user">
            {{user.name}}
            <small class="text-muted"> - {{user.email}}</small>
          </mat-option>
          }
        </mat-autocomplete>
        <mat-error *ngIf="form.get('recipients').invalid">Destinatários obrigatórios</mat-error>
      </mat-form-field>

      <mat-chip-list *ngIf="selectedRecipients().length">
        <mat-label>Destinatários: </mat-label>
        @for (user of selectedRecipients(); track user.id) {
        <mat-chip (removed)="removeUser(user)"
                  class="mr-2">
          {{user.name}}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
        }
      </mat-chip-list>
    </div>

    <div *ngIf="!showTimeSelector"
         class="help-text">
      <h4>Utilize as seguintes palavras-chave:</h4>
      <p>
        <strong>{{'{'}}{{'{'}} os {{'}}'}}</strong> = número OS, <br>
        <strong>{{'{'}}{{'{'}} plate {{'}}'}}</strong> = número da placa, <br>
        <strong>{{'{'}}{{'{'}} company {{'}}'}}</strong> = nome empresa, <br>
        <strong>{{'{'}}{{'{'}} client {{'}}'}}</strong> = Nome Cliente, <br>
        <strong>{{'{'}}{{'{'}} budget {{'}}'}}</strong> = Número Orçamento, <br>
        <strong>{{'{'}}{{'{'}} consultor {{'}}'}}</strong> = Nome do Consultor.
      </p>
      <p>Exemplo de mensagem: Uma nova OS {{'{'}}{{'{'}} os {{'}}'}} para a placa {{'{'}}{{'{'}} plate {{'}}'}} em
        {{'{'}}{{'{'}} company {{'}}'}} acaba de ser fechada.</p>
    </div>

    <mat-dialog-actions>
      <button mat-raised-button
              color="warn"
              [mat-dialog-close]="false">Cancelar</button>
      <button mat-raised-button
              color="primary"
              (click)="save()"
              [disabled]="form.invalid">Salvar</button>
      <button mat-raised-button
              color="accent"
              (click)="deleteMessage()"
              *ngIf="form.get('_id').value && (profile | canAccess: 'RECORDS.controlMessages.delete')">Excluir</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
